import * as React from 'react';

const ThreeHundredSixtyIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7.00049C6.48 7.00049 2 9.24049 2 12.0005C2 14.2405 4.94 16.1305 9 16.7705V20.0005L13 16.0005L9 12.0005V14.7305C5.85 14.1705 4 12.8305 4 12.0005C4 10.9405 7.04 9.00049 12 9.00049C16.96 9.00049 20 10.9405 20 12.0005C20 12.7305 18.54 13.8905 16 14.5305V16.5805C19.53 15.8105 22 14.0505 22 12.0005C22 9.24049 17.52 7.00049 12 7.00049Z"
      fill="black"
      fillOpacity="0.75"
    />
  </svg>
);

export default ThreeHundredSixtyIcon;
